import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OrderRepository from "../../../repository/OrderRepository";
import Order from "../../../model/Order";
import store from "../../../storeWire";
import { initial } from "underscore";
import { __remove, __set } from "../../axios_indicator";

export const fetchOrderList = createAsyncThunk('order_fetchOrderList', async (params) => {
    __set('ORDER_API_CALL');
    return new Order().toObjectWithOrderID(
        await new OrderRepository().fetchOrderList(params.keyword, params.searchType, params.timeSpan, params.start, params.pageSize, params.sortBy, params.sortOrder, params.filterByOption)
    );
});
export const fetchHeaderOrderDetail = createAsyncThunk('order_fetchHeaderOrderDetail', async (params) => {
    __set('ORDER_HEADER_DETAIL_API_CALL');
    return await new OrderRepository().fetchHeaderOrderDetail(params.orderNumber)
});
export const sendEmailOrder = createAsyncThunk('order_sendEmailOrder', async (params) => {
    __set('ORDER_EMAIL_API_CALL');
    return await new OrderRepository().sendEmailOrder(params.from, params.to, params.cc, params.subject, params.emailBody)
});
export const fetchOrderListByLineItem = createAsyncThunk('order_fetchOrderListByLineItem', async (params) => {
    __set('ORDER_API_CALL');
    return await new OrderRepository().fetchOrderListByLineItem(params.orderNumber)
});
export const fetchOrderListByDelivery = createAsyncThunk('order_fetchOrderListByDelivery', async (params) => {
    __set('ORDER_API_CALL');
    return await new OrderRepository().fetchOrderListByDelivery(params.orderNumber)
});
export const placeYourOrder = createAsyncThunk('order_placeYourOrder', async (params) => {
    __set('PLACE_ORDER_API_CALL');
    return await new OrderRepository().placeYourOrder(params)
});
export const fetchPlaceOrderItems = createAsyncThunk('order_fetchPlaceOrderItems', async (orderId) => {
    // __set('PLACE_ORDER_API_CALL');
    return await new OrderRepository().fetchPlaceOrderItems(orderId)
});
export const orderDownloadSingleInvoice = createAsyncThunk('order_orderDownloadSingleInvoice', async (params) => {
    __set('ORDER_DOWNLOAD_API_CALL');
    return await new OrderRepository().orderDownloadSingleInvoice(params.invoiceNumber);
});
export const exportOrder = createAsyncThunk('order_exportOrder', async (params) => {
    __set('ORDER_DOWNLOAD_API_CALL');
    return await new OrderRepository().exportOrder(params);
});
export const fetchExportOrderCount = createAsyncThunk('order_fetchExportOrderCount', async () => {
    __set('ORDER_EXPORT_COUNT_API_CALL');
    return await new OrderRepository().fetchOrderExportCount();
});

export const fetchManufacturerList = createAsyncThunk('order_fetchManufacturerList', async () => {
    __set('ORDER_MANUFACTURE_API_CALL');
    return await new OrderRepository().fetchManufacturerList();
});
const initialState = {
    orderList: {},
    headerOrderDetail: {},
    orderLineItemList: {},
    orderDeliveryList: {},
    placeOrderItemList: {},
    placeOrderLoading: false,
    orderExportCount:0,
    orderManuFactureList: {},
};
const slice = createSlice({
    name: "Order",
    initialState: initialState,
    reducers: {
        setPlaceOrderLoading: {
            reducer: (state, action) => {
                state.placeOrderLoading = action.payload
            }
        }
    },
    extraReducers: {
        [fetchOrderList.fulfilled]: (state, { payload }) => {
            state.orderList = payload;
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
            return state;
        },
        [fetchOrderList.rejected]: (state, { payload }) => {
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
        },
        [fetchHeaderOrderDetail.fulfilled]: (state, { payload }) => {
            state.headerOrderDetail = payload.data.orderHeaderDetail;
            __remove('ORDER_HEADER_DETAIL_API_CALL');
            return state;
        },
        [fetchHeaderOrderDetail.rejected]: (state, { payload }) => {
            __remove('ORDER_HEADER_DETAIL_API_CALL');
        },
        [sendEmailOrder.fulfilled]: (state, { payload }) => {
            __remove('ORDER_EMAIL_API_CALL');
        },
        [sendEmailOrder.rejected]: (state, { payload }) => {
            __remove('ORDER_EMAIL_API_CALL');
        },
        [fetchOrderListByLineItem.fulfilled]: (state, { payload }) => {
            let orderNumber = payload.data.orderNumber
            let tempArr = { ...state.orderLineItemList }
            tempArr[orderNumber] = payload.data.orderItemList
            state.orderLineItemList = tempArr
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
            return state;
        },
        [fetchOrderListByLineItem.rejected]: (state, { payload }) => {
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
        },
        [fetchOrderListByDelivery.fulfilled]: (state, { payload }) => {
            state.orderDeliveryList = payload.data.orderItemList
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
            return state;
        },
        [fetchOrderListByDelivery.rejected]: (state, { payload }) => {
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
        },
        [placeYourOrder.fulfilled]: (state, { payload }) => {
            __remove('PLACE_ORDER_API_CALL');
        },
        [placeYourOrder.rejected]: (state, { payload }) => {
            __remove('PLACE_ORDER_API_CALL');
        },
        [fetchPlaceOrderItems.fulfilled]: (state, { payload }) => {
            state.placeOrderItemList = payload.items;
            // __remove('PLACE_ORDER_API_CALL');
            return state
        },
        [fetchPlaceOrderItems.rejected]: (state, { payload }) => {
            // __remove('PLACE_ORDER_API_CALL');
        },
        [orderDownloadSingleInvoice.fulfilled]: (state, { payload }) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        },
        [orderDownloadSingleInvoice.rejected]: (state, { payload }) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        },
        [exportOrder.fulfilled]: (state, { payload }) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        },
        [exportOrder.rejected]: (state, { payload }) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        },
        [fetchExportOrderCount.fulfilled]: (state, { payload }) => {
            state.orderExportCount = payload;
            __remove('ORDER_EXPORT_COUNT_API_CALL');
        },
        [fetchExportOrderCount.rejected]: (state, { payload }) => {
            __remove('ORDER_EXPORT_COUNT_API_CALL');
        },
        [fetchManufacturerList.fulfilled]: (state, { payload }) => {
            state.orderManuFactureList = payload;
            
            setTimeout(() => {
                __remove('ORDER_MANUFACTURE_API_CALL');
            }, 2000);
            return state;
        },
        [fetchManufacturerList.rejected]: (state, { payload }) => {
            __remove('ORDER_MANUFACTURE_API_CALL');
        },
    },
});

export let { setPlaceOrderLoading } = slice.actions;

export default slice.reducer;
